import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FileCheck, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { navigate('/login', { replace: true }); return; }
      try {
        const res = await axios.post(`${API}/auth/session`, {}, {
          headers: { 'X-Session-ID': sessionId },
          withCredentials: true,
        });
        setUser(res.data);
        window.history.replaceState(null, '', '/');
        navigate('/', { replace: true, state: { user: res.data } });
      } catch (e) {
        navigate('/login', { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="flex h-screen flex-col items-center justify-center bg-slate-50">
      <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-600 shadow-lg">
        <FileCheck className="h-6 w-6 text-white" />
      </div>
      <div className="mt-5 flex items-center gap-2 text-slate-500">
        <Loader2 className="h-4 w-4 animate-spin" /> Signing you in...
      </div>
    </div>
  );
}
